
<div class="row">
    <div class="col-md-1"><h6><span class="text-gray">Biller:</span></h6></div>
    <div class="col-md-2"><h6 style="color:navy">{{biller_name}}</h6></div>
    <div class="col-md-1"><h6><span class="text-gray">Fleet:</span></h6></div>
    <div class="col-md-2"><h6 style="color:navy">{{fleet_name}}</h6></div>
    <div class="col-md-2"><h6><span class="text-gray">Bill Period:</span></h6></div>
    <div class="col-md-4"><h6 style="color:navy">({{ (formatDate(params['from']) !== null && params['from'] != '0000-00-00') ? (formatDate(params['from']) | date: 'dd MMM yyyy') : "No Date"  }})
        - ({{ (formatDate(params['to']) !== null && params['to'] != '0000-00-00') ? (formatDate(params['to']) | date: 'dd MMM yyyy') : "No Date"  }})<br/></h6></div>
</div>
<hr/>
<span><small class="text-danger"><i>* Table listed records are result of above filters. No data to display  means no expense record available within the filter values.</i></small><br/></span>

<div class="row" style="overflow-y: auto; max-height:450px;">
    <div *ngFor="let t of bi_tables" class="col-12">
        <div *ngIf="t.table_name == 'fuels'" class="col-12">
            <h5 class="text-success">Fuels</h5><br/>
            <ngx-datatable  
                class="material"
                [rows]="bi_fuels"
                [columnMode]="'force'"
                [footerHeight]="30"
                [rowHeight]="'auto'"
                [limit]="10"
                [selectionType]="'single'"
                >
                
                <ngx-datatable-column prop="id" headerClass="header" name="" [width]="20">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="text-center">
                            <input type="checkbox" ng-true-value="1" ng-false-value="0" id="fuelCheckbox" [checked]="checkValue(row.id, 'fuels')" 
                                (change)="setRecord(row,'fuels', $event)">
                            </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="date" headerClass="header" name="Date" [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="litres" headerClass="header" name="Liters" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="cost" headerClass="header" name="Cost" [width]="100">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="text-right">
                            $ {{ (value !== null) ?  (value | number:'1.2-2') : "0"}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="receipt_no" headerClass="header" name="Receipt No." [width]="120"></ngx-datatable-column>
            </ngx-datatable>
            <hr/>
        </div>
        <div *ngIf="t.table_name == 'fuel_cards'" class="col-12">
            <h5 class="text-success">Fuel Cards</h5><br/>
            <ngx-datatable  
                class="material"
                [rows]="bi_fuel_cards"
                [columnMode]="'force'"
                [footerHeight]="30"
                [rowHeight]="'auto'"
                [limit]="10"
                [selectionType]="'checkbox'"
                (select)="onSelect($event, 'fuel_cards')"
                >
                
                <ngx-datatable-column prop="id" headerClass="header" name="" [width]="20">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="text-center">
                            <input type="checkbox" ng-true-value="1" ng-false-value="0" id="fuelCheckbox" [checked]="checkValue(row.id, 'fuel_cards')" 
                                (change)="setRecord(row,'fuel_cards', $event)">
                            </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="activation_date" headerClass="header" name="Activation Date" [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="card_name" headerClass="header" name="Card Name" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="card_no" headerClass="header" name="Card No." [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="credit_limit" headerClass="header" name="Credit Limit" [width]="100">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="text-right">
                            $ {{ (value !== null) ?  (value | number:'1.2-2') : "0"}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
            <hr/>
        </div>
        <div *ngIf="t.table_name == 'tyres'" class="col-12">
            <h5 class="text-success">Tyres</h5><br/>
            <ngx-datatable  
                class="material"
                [rows]="bi_tyres"
                [columnMode]="'force'"
                [footerHeight]="30"
                [rowHeight]="'auto'"
                [limit]="10"
                [selectionType]="'checkbox'"
                (select)="onSelect($event, 'tyres')"
                >
                
                <ngx-datatable-column prop="id" headerClass="header" name="" [width]="20">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="text-center">
                            <input type="checkbox" ng-true-value="1" ng-false-value="0" id="tyreCheckbox" [checked]="checkValue(row.id, 'tyres')" 
                                (change)="setRecord(row,'tyres', $event)">
                            </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="date_done" headerClass="header" name="Date" [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="receipt_no" headerClass="header" name="Receipt No." [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="tyre_description" headerClass="header" name="Description" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="cost" headerClass="header" name="Cost" [width]="100">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="text-right">
                            $ {{ (value !== null) ?  (value | number:'1.2-2') : "0"}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
            <hr/>
        </div>
        <div *ngIf="t.table_name == 'fleet_insurance'" class="col-12">
            <h5 class="text-success">Insurances</h5><br/>
            <ngx-datatable  
                class="material"
                [rows]="bi_insurance"
                [columnMode]="'force'"
                [footerHeight]="30"
                [rowHeight]="'auto'"
                [limit]="10"
                [selectionType]="'checkbox'"
                (select)="onSelect($event, 'fleet_insurance')"
                >
                
                <ngx-datatable-column prop="id" headerClass="header" name="" [width]="20">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="text-center">
                            <input type="checkbox" ng-true-value="1" ng-false-value="0" id="insuranceCheckbox" [checked]="checkValue(row.id, 'fleet_insurance')" 
                                (change)="setRecord(row,'fleet_insurance', $event)">
                            </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="expiry_date" headerClass="header" name="Expiry Date" [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="insurance_name" headerClass="header" name="Name" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="receipt_no" headerClass="header" name="Receipt No." [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="cost" headerClass="header" name="Cost" [width]="100">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="text-right">
                            $ {{ (value !== null) ?  (value | number:'1.2-2') : "0"}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
            <hr/>
        </div>
        <div *ngIf="t.table_name == 'rego_registrations'" class="col-12">
            <h5 class="text-success">Registrations</h5><br/>
            <ngx-datatable  
                class="material"
                [rows]="bi_rego"
                [columnMode]="'force'"
                [footerHeight]="30"
                [rowHeight]="'auto'"
                [limit]="10"
                [selectionType]="'checkbox'"
                (select)="onSelect($event, 'rego_registrations')"
                >
                
                <ngx-datatable-column prop="id" headerClass="header" name="" [width]="20">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="text-center">
                            <input type="checkbox" ng-true-value="1" ng-false-value="0" id="regoCheckbox" [checked]="checkValue(row.id, 'rego_registrations')" 
                                (change)="setRecord(row,'rego_registrations', $event)">
                            </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="expiry_date" headerClass="header" name="Expiry Date" [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="reg_no" headerClass="header" name="Registration No." [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="receipt_no" headerClass="header" name="Receipt No." [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="amount" headerClass="header" name="Cost" [width]="100">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="text-right">
                            $ {{ (value !== null) ?  (value | number:'1.2-2') : "0"}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
            <hr/>
        </div>
        <div *ngIf="t.table_name == 'other_costs'" class="col-12">
            <h5 class="text-success">Other Costs</h5><br/>
            <ngx-datatable  
                class="material"
                [rows]="bi_other"
                [columnMode]="'force'"
                [footerHeight]="30"
                [rowHeight]="'auto'"
                [limit]="10"
                [selectionType]="'checkbox'"
                (select)="onSelect($event, 'other_costs')"
                >
                
                <ngx-datatable-column prop="id" headerClass="header" name="" [width]="20">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="text-center">
                            <input type="checkbox" ng-true-value="1" ng-false-value="0" id="otherCheckbox" [checked]="checkValue(row.id, 'other_costs')" 
                                (change)="setRecord(row,'other_costs', $event)">
                            </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="date" headerClass="header" name="Date" [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="description" headerClass="header" name="Description" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="details" headerClass="header" name="Details" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="cost" headerClass="header" name="Cost" [width]="100">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="text-right">
                            $ {{ (value !== null) ?  (value | number:'1.2-2') : "0"}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
            <hr/>
        </div>
        <div *ngIf="t.table_name == 'services'" class="col-12">
            <h5 class="text-success">Services</h5><br/>
            <ngx-datatable  
                class="material"
                [rows]="bi_services"
                [columnMode]="'force'"
                [footerHeight]="30"
                [rowHeight]="'auto'"
                [limit]="10"
                [selectionType]="'checkbox'"
                (select)="onSelect($event, 'services')"
                >
                
                <ngx-datatable-column prop="id" headerClass="header" name="" [width]="20">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="text-center">
                            <input type="checkbox" ng-true-value="1" ng-false-value="0" id="serviceCheckbox" [checked]="checkValue(row.id, 'services')" 
                                (change)="setRecord(row,'services', $event)">
                            </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="date_done" headerClass="header" name="Date" [width]="100">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column prop="service_description" headerClass="header" name="Description" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="receipt_no" headerClass="header" name="Receipt No." [width]="100"></ngx-datatable-column>
                <ngx-datatable-column prop="cost" headerClass="header" name="Cost" [width]="100">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="text-right">
                            $ {{ (value !== null) ?  (value | number:'1.2-2') : "0"}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
            <hr/>
        </div>
        <div *ngIf="t.table_name == 'repairs'" class="col-12">
            <h5 class="text-success">Repairs</h5><br/>
            <ngx-datatable  
            class="material"
            [rows]="bi_repairs"
            [columnMode]="'force'"
            [footerHeight]="30"
            [rowHeight]="'auto'"
            [limit]="10"
            [selectionType]="'checkbox'"
            (select)="onSelect($event, 'repairs')"
            >
            
            <ngx-datatable-column prop="id" headerClass="header" name="" [width]="20">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="text-center">
                        <input type="checkbox" ng-true-value="1" ng-false-value="0" id="repairCheckbox" [checked]="checkValue(row.id, 'repairs')" 
                            (change)="setRecord(row,'repairs', $event)">
                        </span>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="date_done" headerClass="header" name="Date" [width]="100">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="repair_description" headerClass="header" name="Description" [width]="100"></ngx-datatable-column>
            <ngx-datatable-column prop="receipt_no" headerClass="header" name="Receipt No." [width]="100"></ngx-datatable-column>
            <ngx-datatable-column prop="cost" headerClass="header" name="Cost" [width]="100">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div class="text-right">
                        $ {{ (value !== null) ?  (value | number:'1.2-2') : "0"}}
                    </div>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
        <hr/>
        </div>
    </div>
</div>

<hr/>
<div>
    <button type="button" class="btn btn-sm btn-success" (click)="saveImport()">Done</button> &nbsp;&nbsp;&nbsp;
    <i class="fa fa-spinner fa-lg fa-spin" *ngIf="spinner == true"></i>
</div>